/*
 * Copyright (c) 2024. Spin in het Web B.V. Apeldoorn NL.
 * Deze software is géén open source. Het auteursrecht van deze software
 * ligt bij Spin in het Web B.V. en/of Jellybean B.V. en/of de auteur.
 * Gebruik van deze software is onderhevig aan een licentieovereenkomst.
 * www.spininhetweb.nl
 */

/*
* index.ts
* 24-9-2024 - Jelmer Jellema - Spin in het Web B.V.
*/

export * from './localconfig';
